export type RoleScope = "company" | "project"

export type RoleTone = "owner" | "member" | "producer" | "director" | "contributor" | "viewer" | "neutral"

const COMPANY_TONES: Record<string, RoleTone> = { owner: "owner", member: "member" }
const PROJECT_TONES: Record<string, RoleTone> = {
  producer: "producer",
  director: "director",
  member: "contributor",
  viewer: "viewer",
}

const BADGE_CLASS: Record<RoleTone, string> = {
  owner: "bg-[var(--ui-role-owner-bg)] text-[var(--ui-role-owner-fg)]",
  member: "bg-[var(--ui-role-member-bg)] text-[var(--ui-role-member-fg)]",
  producer: "bg-[var(--ui-role-producer-bg)] text-[var(--ui-role-producer-fg)]",
  director: "bg-[var(--ui-role-director-bg)] text-[var(--ui-role-director-fg)]",
  contributor: "bg-[var(--ui-role-contributor-bg)] text-[var(--ui-role-contributor-fg)]",
  viewer: "bg-[var(--ui-role-viewer-bg)] text-[var(--ui-role-viewer-fg)]",
  neutral: "bg-[var(--ui-badge-neutral-bg)] text-[var(--ui-badge-neutral-fg)]",
}

const DOT_CLASS: Record<RoleTone, string> = {
  owner: "bg-[var(--ui-role-owner-dot)]",
  member: "bg-[var(--ui-role-member-dot)]",
  producer: "bg-[var(--ui-role-producer-dot)]",
  director: "bg-[var(--ui-role-director-dot)]",
  contributor: "bg-[var(--ui-role-contributor-dot)]",
  viewer: "bg-[var(--ui-role-viewer-dot)]",
  neutral: "bg-ui-text-muted",
}

export function roleTone(scope: RoleScope, role: string): RoleTone {
  const tones = scope === "company" ? COMPANY_TONES : PROJECT_TONES
  return Object.prototype.hasOwnProperty.call(tones, role) ? tones[role] : "neutral"
}

export function roleBadgeClassName(scope: RoleScope, role: string): string {
  return BADGE_CLASS[roleTone(scope, role)]
}

export function roleDotClassName(scope: RoleScope, role: string): string {
  return DOT_CLASS[roleTone(scope, role)]
}

export function roleLabelKey(scope: RoleScope, role: string): string {
  return scope === "company" ? `company:companyRoles.${role}` : `company:projectRoles.${role}`
}

export function roleHintKey(scope: RoleScope, role: string): string {
  return `company:roleHints.${scope}.${role}`
}
